import { useContext } from 'react'
import { useRouter } from 'next/router'
import { useFeature } from '@pcln/feature-components'
import BootstrapDataContext from '@/context/BootstrapDataContext'
import isLoadedInAppView from '@/shared-utils/isLoadedInAppView'
import { getTrafficInfo } from './utils'

const useAppBanner = () => {
  const { query } = useRouter()
  const bootstrapData = useContext(BootstrapDataContext)
  const {
    isCookieSetToHideAppBanner,
    isMobile = false,
    referral
  } = bootstrapData
  const { isPaid, isBranded, isBlackListed } = getTrafficInfo(query, referral)
  const isAppBannerEnabled = useFeature('siteExperience.appBannerEnabled')

  const hideAppBanner =
    !isAppBannerEnabled ||
    isCookieSetToHideAppBanner ||
    isLoadedInAppView(query) ||
    !isMobile ||
    (isPaid && !isBranded) ||
    isBlackListed

  const showAppBanner = !hideAppBanner

  return showAppBanner
}

export default useAppBanner
